import { Language } from '../../model';

/**
 * Function takes 2 language objects to compare based on language codes. Used in compareWith property of mat-selects
 * @param firstLanguage object to compare
 * @param secondLanguage object to compare to
 */
export const compareLanguages = (firstLanguage: Language, secondLanguage: Language): boolean => {
  return firstLanguage.lnCode === secondLanguage.lnCode;
};
